import {
  INBOX_FILTER,
  INBOX_FILTER_SUCCESS,
  INBOX_FILTER_ERROR,
  INBOX_SEGMENTS,
  INBOX_SEGMENTS_SUCCESS,
  INBOX_SEGMENTS_ERROR,
} from "./actionTypes"


export const inboxFilter = data => ({
  type: INBOX_FILTER,
  payload: data
});

export const inboxFilterSuccess = data => ({
  type: INBOX_FILTER_SUCCESS,
  payload: {data}
});

export const inboxFilterError = error => ({
  type: INBOX_FILTER_ERROR,
  payload: error,
});

export const inboxSegments = data => ({
  type: INBOX_SEGMENTS,
  payload: data
});

export const inboxSegmentsSuccess = data => ({
  type: INBOX_SEGMENTS_SUCCESS,
  payload: {data}
});

export const inboxSegmentsError = error => ({
  type: INBOX_SEGMENTS_ERROR,
  payload: error,
});